import { render, staticRenderFns } from "./FiatDeposit.vue?vue&type=template&id=3fc9e851&scoped=true"
import script from "./FiatDeposit.vue?vue&type=script&lang=js"
export * from "./FiatDeposit.vue?vue&type=script&lang=js"
import style0 from "./FiatDeposit.vue?vue&type=style&index=0&id=3fc9e851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc9e851",
  null
  
)

export default component.exports